/* eslint-disable prefer-arrow-callback */
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Container from './Containers';
import { addUtils } from './class-name-helpers';

export const DEFAULT_BANNER_IMAGE = 'https://images.ctfassets.net/gtqjh9j40j4m/2QFaRapDaMAjKdaJ3fo6YJ/b3d7ea49ca30fcfe774ceeb1984afe75/5ffd8144a7409cd29c512446_lasers.svg';

const selectBackgroundProperties = backgroundImage => ({
  backgroundImage: `url(${backgroundImage.url})`,
  backgroundPosition: backgroundImage.position || 'center top',
});

function PageSection({
  children,
  className,
  hero,
  banner,
  container,
  backgroundImage,
  ...props
}) {
  const variants = {
    'ss_page-section--hero': hero,
    'ss_page-section--banner': banner,
  };

  const { restProps, utilClassNames } = addUtils(props);

  return (
    <section
      className={clsx(className, 'ss_page-section', variants, utilClassNames)}
      style={backgroundImage?.url && selectBackgroundProperties(backgroundImage)}
      {...restProps}
    >
      {
        container
          ? <Container>{children}</Container>
          : children
      }
    </section>
  );
}

PageSection.defaultProps = {
  className: '',
  hero: false,
  banner: false,
  center: false,
  bgDarkMid: false,
  container: true,
  backgroundImage: undefined,
};

PageSection.propTypes = {
  backgroundImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    position: PropTypes.string,
  }),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  hero: PropTypes.bool,
  banner: PropTypes.bool,
  center: PropTypes.bool,
  bgDarkMid: PropTypes.bool,
  container: PropTypes.bool,
};

export default PageSection;
